module.exports = __webpack_public_path__ + "static/media/pri.a1964261.svg";